import { color } from "src/styles/globals";
import styled from "styled-components";
import { Collapse as SundayCollapse } from "sunday-component";
import { CustomCollapseProps } from "sunday-component/lib/src/components/Collapse/Collapse";

const StyledCollapse = styled(SundayCollapse)`
  .sunday-component-collapse-header {
    margin: 0;
    border-top: 1px solid ${color.coolGreyCG3};
    border-bottom: 0;
    padding-top: 24px !important;
  }
  .sunday-component-collapse-header.sunday-component-collapse-header-collapsible-only {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  .sunday-component-collapse-extra {
    display: none;
  }
`;

export const Collapse = (props: CustomCollapseProps) => (
  <StyledCollapse {...props} />
);
